export default __webpack_public_path__ + "static/media/myachery.9ed0d268.png";